import React from 'react';
import api from '../../../../../api';
import ConfirmDialog from "../../../../Modal/ConfirmDialog";
import './AddCallForward.css';

class WelcomeBranchVariableRule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            rules: [],
            errors: [],
            errorMessage: '',
            message: '',
            confirmDialog: false,
            delete_index: null,
            disablebutton: false,
        };
    }

    componentDidMount() {
        this.onLoad();
    }

    componentDidUpdate(prevProps) {
        if (this.props.branch_id !== prevProps.branch_id) {
            this.onLoad();
        }
    }

    onLoad = () => {
        this.setState({ loading: true });
        api.outbound.getWelcomeBranchVariableRules({ workspace_id: this.props.workspace_id, branch_id: this.props.branch_id })
            .then(data => {
                try {
                    if (data.status && Array.isArray(data.data) && data.data.length) {
                        this.setState({ rules: data.data, loading: false });
                    } else {
                        this.setState({
                            rules: [{ workspace_id: this.props.workspace_id, branch_id: this.props.branch_id, variable_name: '', variable_value: '' }],
                            loading: false,
                        });
                    }
                } catch (err) {
                    this.setState({ loading: false });
                    console.log(err);
                }
            })
            .catch(() => this.setState({ loading: false }));
    };

    addNewRule = () => {
        const rules = [...this.state.rules, { workspace_id: this.props.workspace_id, branch_id: this.props.branch_id, variable_name: '', variable_value: '' }];
        this.setState({ rules });
    };

    updateField = (e, index, field) => {
        let value = e.target.value.trimStart();
        const rules = this.state.rules.map((rule, i) => i === index ? { ...rule, [field]: value } : rule);
        this.setState({ rules });
    };

    deleteRule = (e, index, id) => {
        this.setState({ delete_index: { index, id }, confirmDialog: true });
    };

    deleteCredentials = () => {
        this.setState({ loading: true, confirmDialog: false });
        const { delete_index, rules } = this.state;

        if (delete_index.id) {
            api.outbound.deleteWelcomeBranchVariableRule({ id: delete_index.id, workspace_id: this.props.workspace_id, branch_id: this.props.branch_id })
                .then(res => {
                    if (res.status) {
                        const updated = rules.filter(rule => rule.id !== delete_index.id);
                        this.setState({ loading: false, rules: updated, delete_index: null, message: 'Rule deleted successfully.' }, () => {
                            setTimeout(() => this.setState({ message: '' }), 4000);
                        });
                    } else {
                        this.setState({ loading: false, delete_index: null, errorMessage: res.message || 'Failed to delete rule.' });
                    }
                })
                .catch(err => {
                    this.setState({ loading: false, delete_index: null, errorMessage: 'Failed to delete rule.' });
                    console.log(err);
                });
        } else {
            const updated = rules.filter((_, i) => i !== delete_index.index);
            this.setState({ loading: false, rules: updated, delete_index: null, message: 'Rule deleted successfully.' }, () => {
                setTimeout(() => this.setState({ message: '' }), 4000);
            });
        }
    };

    toggleConfirmModal = () => {
        this.setState({ confirmDialog: !this.state.confirmDialog });
    };

    validateRules = (rules) => {
        const errors = [];
        rules.forEach((rule, index) => {
            let err = {};
            let iserr = false;
            if (!rule.variable_name || rule.variable_name.trim() === '') {
                err = { ...err, index, variable_name: 'This field is required.' };
                iserr = true;
            }
            if (!rule.variable_value || rule.variable_value.trim() === '') {
                err = { ...err, index, variable_value: 'This field is required.' };
                iserr = true;
            }
            if (iserr) errors.push(err);
        });
        return errors;
    };

    saveRules = () => {
        const { rules } = this.state;
        const validate_errors = this.validateRules(rules);
        if (validate_errors.length > 0) {
            this.setState({ errors: validate_errors, errorMessage: 'Fill in all the required fields.' });
            return;
        }
        this.setState({ loading: true, disablebutton: true, errors: [], errorMessage: '' });

        api.outbound.saveWelcomeBranchVariableRule({
            workspace_id: this.props.workspace_id,
            branch_id: this.props.branch_id,
            rules: rules.map(r => ({ id: r.id || null, variable_name: r.variable_name.trim(), variable_value: r.variable_value.trim() })),
        })
            .then(res => {
                if (res.status) {
                    this.setState({ loading: false, disablebutton: false, rules: res.data || rules, message: 'Rules saved successfully.' }, () => {
                        setTimeout(() => { this.setState({ message: '' }); this.props.popupClose(); }, 2000);
                    });
                } else {
                    this.setState({ loading: false, disablebutton: false, errorMessage: res.message || 'Failed to save rules.' });
                }
            })
            .catch(err => {
                this.setState({ loading: false, disablebutton: false });
                console.log(err);
            });
    };

    render() {
        const { rules, errors, message, errorMessage, loading, confirmDialog, disablebutton } = this.state;

        return (
            <div>
                <ConfirmDialog
                    show={confirmDialog}
                    toggleModal={this.deleteCredentials}
                    closeAction={this.toggleConfirmModal}
                    title="Confirm your action"
                    message="Do you really want to delete this rule?"
                />
                {loading && <div className="ui loading form"></div>}

                <div className="yr-chat-round-box yr-closebtn">
                    <button type="button" className="close linear-gradient" onClick={() => this.props.popupClose()}>&#10006;</button>

                    <div className="col-md-12" style={{ marginTop: '10px', marginLeft: '-10px' }}>
                        Start call from this branch when these variable conditions are met:
                    </div>

                    <div className="row" style={{ marginLeft: '1px' }}>
                        <button className="btn add-link pull-right" style={{ width: '100%', textAlign: 'left', marginLeft: '0px' }} onClick={this.addNewRule}>
                            +Add variable rule
                        </button>
                        {message && <div className="ui message green" style={{ marginTop: '10px', textAlign: 'center' }}>{message}</div>}
                        {errorMessage && <div className="ui message red" style={{ marginTop: '10px', width: '100%' }}>{errorMessage}</div>}
                    </div>

                    {rules.length > 0 && (
                        <div className="row">
                            {rules.map((rule, index) => {
                                const err = errors.filter(e => e.index === index);
                                return (
                                    <React.Fragment key={index}>
                                        <div className={`col-md-11 ${index === 0 ? 'primaryborder' : ''}`} style={{ display: 'flex', columnGap: 10, marginTop: 10 }}>
                                            <div className="form-group" style={{ flex: 1 }}>
                                                <input
                                                    type="text"
                                                    className={`form-control ${err && err[0]?.variable_name ? 'input-error' : ''}`}
                                                    placeholder="Variable Name"
                                                    value={rule.variable_name}
                                                    onChange={e => this.updateField(e, index, 'variable_name')}
                                                />
                                                {err && err[0]?.variable_name && (
                                                    <div style={{ color: '#c00', fontSize: 12, marginTop: 4 }}>{err[0].variable_name}</div>
                                                )}
                                            </div>
                                            <div className="form-group" style={{ flex: 1 }}>
                                                <input
                                                    type="text"
                                                    className={`form-control ${err && err[0]?.variable_value ? 'input-error' : ''}`}
                                                    placeholder="Variable Value"
                                                    value={rule.variable_value}
                                                    onChange={e => this.updateField(e, index, 'variable_value')}
                                                />
                                                {err && err[0]?.variable_value && (
                                                    <div style={{ color: '#c00', fontSize: 12, marginTop: 4 }}>{err[0].variable_value}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-1" style={{ display: 'flex', columnGap: 10, marginTop: index === 0 ? '30px' : '18px' }}>
                                            <span style={{ color: 'red', cursor: 'pointer', marginTop: index === 0 ? '-10px' : '0px' }} onClick={e => this.deleteRule(e, index, rule.id || null)} title="Delete rule">
                                                <i style={{ color: 'red', cursor: 'pointer' }} className="fa fa-trash"></i>
                                            </span>
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="row">
                    {rules.length > 0 && (
                        <div className="col-12 d-flex justify-content-end">
                            <button type="reset" className="btn linear-gradient-cancel yr-cancelbtn mg-r" onClick={() => this.props.popupClose()}><span>Close</span></button>
                            <button type="submit" disabled={disablebutton} className="btn linear-gradient yr-submitbtn" onClick={this.saveRules}>Save</button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default WelcomeBranchVariableRule;
